import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton, Typography, Box } from '@mui/material';
import { PiTrash, PiFile, PiFilePdf, PiFileText } from 'react-icons/pi';

interface FileListProps {
  files: File[];
  onRemoveFile: (index: number) => void;
}

const getFileIcon = (file: File) => {
  if (file.type === 'application/pdf') return <PiFilePdf size={24} color="#d32f2f" />;
  if (file.type.includes('word')) return <PiFileText size={24} color="#1976d2" />;
  if (file.type === 'application/json') return <PiFile size={24} color="#2e7d32" />;
  return <PiFile size={24} />;
};

const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export default function FileList({ files, onRemoveFile }: FileListProps) {
  if (files.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body2" color="text.secondary">
          No files selected
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        Selected Files ({files.length})
      </Typography>
      <List>
        {files.map((file, index) => (
          <ListItem key={`${file.name}-${index}`} divider>
            <ListItemIcon>
              {getFileIcon(file)}
            </ListItemIcon>
            <ListItemText
              primary={file.name}
              secondary={formatFileSize(file.size)}
            />
            <ListItemSecondaryAction>
              <IconButton 
                edge="end" 
                onClick={() => onRemoveFile(index)}
                size="small"
              >
                <PiTrash size={20} />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}